module.exports = __webpack_public_path__ + "2ee56ecdb443dd3cf25aed76d3c8c068.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-11-harrison/diary.jpg
// module id = 629
// module chunks = 0